import vkbeautify from "vkbeautify";
import {
    ANDROID_RESOURCE_FILENAME,
    ANDROID_XML_ATTRIBUTE_NAME,
    ANDROID_XML_TAG_RESOURCES,
    ANDROID_XML_TAG_STRING,
    FULL_WIDTH_CHARACTERS,
    HALF_WIDTH_CHARACTERS
} from "../../constant";
import BaseResourceWriter from "./BaseResourceWriter";

export default class AndroidResourceWriter extends BaseResourceWriter {
    constructor(languageCode,
                trimWhitespace,
                replacePlaceholders,
                replaceFullWidthPlaceholders,
                replaceWhitespaceCharacters,
                retainEmptyValue,
                header) {
        super(languageCode,
            trimWhitespace,
            replacePlaceholders,
            replaceFullWidthPlaceholders,
            replaceWhitespaceCharacters,
            retainEmptyValue,
            header);
        if (header) this.xml = document.implementation.createDocument(null, ANDROID_XML_TAG_RESOURCES);
    }

    write(key, value) {
        if (this.xml) {
            let checkedKey = key.trim().replace(/^(\d*)(\w*)/g, "$2").replace(/[^A-Za-z_\d]/g, "_");
            if (!checkedKey) return;
            let checkedValue = value;
            if (this.trimWhitespace) checkedValue = checkedValue.trim();
            else {
                let firstIndex = 0;
                for (let i = 0; i < checkedValue.length; i++) {
                    if (checkedValue.charAt(i) === " ") firstIndex++;
                    else break;
                }
                if (firstIndex > 0) {
                    checkedValue = `${Array(firstIndex).fill("\u00A0").join("")}${checkedValue.substring(firstIndex)}`;
                }
                let lastIndex = checkedValue.length - 1;
                for (let i = checkedValue.length - 1; i >= 0; i--) {
                    if (checkedValue.charAt(i) === " ") lastIndex--;
                    else break;
                }
                if (lastIndex < checkedValue.length - 1) {
                    checkedValue = `${checkedValue.substring(0, lastIndex + 1)}${Array(checkedValue.length - lastIndex - 1).fill("\u00A0").join("")}`;
                }
            }
            if (this.replaceWhitespaceCharacters) checkedValue = checkedValue.replace(/\\/g, "\\\\").replace(/\r\n/g, "\\n").replace(/\r/g, "\\n").replace(/\n/g, "\\n").replace(/\u2028/g, "\\n");
            else checkedValue = checkedValue.replace(/\n/g, "");
            checkedValue = checkedValue.replace(/'/g, "\\'").replace(/"/g, "\\\"");
            if (this.replacePlaceholders) {
                if (this.replaceFullWidthPlaceholders) {
                    for (let i = 0; i < FULL_WIDTH_CHARACTERS.length; i++) {
                        checkedValue = checkedValue.replace(new RegExp(FULL_WIDTH_CHARACTERS[i], "g"), HALF_WIDTH_CHARACTERS[i]);
                    }
                }
                checkedValue = checkedValue.replace(/%(\d\$)?@/g, "%$1s");
            }
            if (!checkedValue && !this.retainEmptyValue) return;
            const element = this.xml.createElement(ANDROID_XML_TAG_STRING);
            element.setAttribute(ANDROID_XML_ATTRIBUTE_NAME, checkedKey);
            element.textContent = checkedValue;
            this.xml.getElementsByTagName(ANDROID_XML_TAG_RESOURCES)[0].appendChild(element);
        }
    }

    addToZip(zip) {
        const xmlString = new XMLSerializer().serializeToString(this.xml);
        return zip.folder(this.languageCode).file(ANDROID_RESOURCE_FILENAME, vkbeautify.xml(xmlString));
    }
}